import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=2d7d6cac&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=2d7d6cac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7d6cac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7d6cac')) {
      api.createRecord('2d7d6cac', component.options)
    } else {
      api.reload('2d7d6cac', component.options)
    }
    module.hot.accept("./PasswordReset.vue?vue&type=template&id=2d7d6cac&scoped=true", function () {
      api.rerender('2d7d6cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PasswordReset.vue"
export default component.exports